import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { lighten } from "polished";

import Link from "../../components/Link";

const SiteNavLink = styled(Link)(props => {
  return {
    display: "block",
    padding: "14px 22px",
    textDecoration: "none",
    fontSize: themeGet("fontSizes.0")(props),
    lineHeight: "12px",
    backgroundColor: props.active
      ? themeGet("colors.footer.bg.top")(props)
      : themeGet("colors.footer")(props),
    color: props.active
      ? themeGet("colors.white.100")(props)
      : themeGet("colors.footer.mail")(props),
    "&:hover": {
      backgroundColor: props.active
        ? themeGet("colors.headlines")(props)
        : lighten(0.02, themeGet("colors.footer.bg.bottom")(props)),
    },
    ["@media screen and (max-width: 576px)"]: {
      fontSize: "11px",
      padding: "11px 10px",
    },
    ["@media screen and (max-width: 400px)"]: {
      fontSize: "11px",
      padding: "11px 6px",
    },
  };
});

SiteNavLink.displayName = "SiteNavLink";

export default SiteNavLink;
